import { Card, Col } from "reactstrap";
import { ColorHeadingBody } from "./ColorHeadingBody";
import { ColoredHeadings } from "../../../../Constant";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { HEADING_DATA } from "../../../../Data/UiKit/Typography";

const ColorCart = () => {
  return (
    <Col sm="12" xl="6">
      <Card className="height-equal">
        <CommonCardHeader title={ColoredHeadings} span={HEADING_DATA} />
        <ColorHeadingBody />
      </Card>
    </Col>
  );
};

export default ColorCart;
